import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("session_token");
  if (token) cfg.headers["X-Session-Token"] = token;
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("session_token");
      if (window.location.pathname !== "/") window.location.href = "/";
    }
    return Promise.reject(err);
  }
);

export const api = {
  authStatus: () => client.get("/auth/status").then((r) => r.data),
  setupPin: (pin) => client.post("/auth/setup-pin", { pin }).then((r) => r.data),
  verifyPin: (pin) => client.post("/auth/verify-pin", { pin }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),

  listSales: (month) => client.get(`/sales`, { params: { month } }).then((r) => r.data),
  createSale: (data) => client.post(`/sales`, data).then((r) => r.data),
  updateSale: (id, data) => client.put(`/sales/${id}`, data).then((r) => r.data),
  deleteSale: (id) => client.delete(`/sales/${id}`).then((r) => r.data),

  listWorkdays: (month) => client.get(`/workdays`, { params: { month } }).then((r) => r.data),
  toggleWorkday: (work_date, sunday_bonus = false) =>
    client.post(`/workdays/toggle`, { work_date, sunday_bonus }).then((r) => r.data),

  dashboard: (month) => client.get(`/dashboard`, { params: { month } }).then((r) => r.data),
};
